import { OuterSubscriber } from 'rxjs/_esm2015/internal/OuterSubscriber';
import { subscribeToResult } from 'rxjs/_esm2015/internal/util/subscribeToResult';
const EMPTY_LAST_VALUE = { type: 'empty' };
export class MergeScanSubscriber extends OuterSubscriber {
    constructor(destination, accumulator, acc) {
        super(destination);
        this.hasValue = false;
        this.hasCompleted = false;
        this.lastValue = EMPTY_LAST_VALUE;
        this.active = false;
        this.index = 0;
        this.accumulator = accumulator;
        this.acc = acc;
    }
    notifyNext(_outerValue, innerValue) {
        const { destination } = this;
        this.acc = innerValue;
        this.hasValue = true;
        if (destination.next !== undefined) {
            destination.next(innerValue);
        }
    }
    notifyComplete(innerSub) {
        const { lastValue } = this;
        this.remove(innerSub);
        this.active = false;
        if (lastValue.type === 'value') {
            this.lastValue = EMPTY_LAST_VALUE;
            this.next(lastValue.value);
        }
        else if (!this.active && this.hasCompleted) {
            if (!this.hasValue && this.destination.next !== undefined) {
                this.destination.next(this.acc);
            }
            if (this.destination.complete !== undefined) {
                this.destination.complete();
            }
        }
    }
    _next(value) {
        if (!this.active) {
            const { index, destination } = this;
            this.index += 1;
            try {
                const result = this.accumulator(this.acc, value);
                this.active = true;
                this._innerSub(result, value, index);
            }
            catch (error) {
                if (destination.error !== undefined) {
                    destination.error(error);
                }
            }
        }
        else {
            this.lastValue = { type: 'value', value };
        }
    }
    _complete() {
        this.hasCompleted = true;
        if (!this.active && this.lastValue.type === 'empty') {
            if (!this.hasValue && this.destination.next !== undefined) {
                this.destination.next(this.acc);
            }
            if (this.destination.complete !== undefined) {
                this.destination.complete();
            }
        }
    }
    _innerSub(ish, value, index) {
        this.add(subscribeToResult(this, ish, value, index));
    }
}
export class MergeScanOperator {
    constructor(accumulator, seed) {
        this.accumulator = accumulator;
        this.seed = seed;
    }
    call(subscriber, source) {
        return source.subscribe(new MergeScanSubscriber(subscriber, this.accumulator, this.seed));
    }
}
export function mergeScanLatest(accumulator, seed) {
    return (source$) => source$.lift(new MergeScanOperator(accumulator, seed));
}

//# sourceMappingURL=mergeScanLatest.js.map
